module.exports = __webpack_public_path__ + "static/media/employee_experience_6.ee14ec92.png";